const INITIAL_STATE = {
  headerExtra: null,
  headerTopExtra: null
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'HEADER_EXTRA':
      return {
        ...state,
        headerExtra: action.payload
      };
    case 'HEADER_TOP_EXTRA':
      return {
        ...state,
        headerTopExtra: action.payload
      };
    default:
      return state;
  }
}
